import React from 'react'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getFullName } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { getButtons } from './nav_bar/nav_bar'
import NavBarItem from './nav_bar/nav_bar_item'
import { getResourceAuthorization, selectEffectiveTogglesForCurrent } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { getUnreadNotificationsCount } from '@verzekeringapp-mono/shared/src/state/selectors/notifications'

const ScreenHeader = () => {
  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const relationToggles = useAppSelector(selectEffectiveTogglesForCurrent)
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)
  const unreadNotificationsCount = useAppSelector(getUnreadNotificationsCount)

  const fullName = useAppSelector(getFullName)

  return (
    <div className='flex h-[86px] items-center justify-end border-b-[0.5px] border-border-subtle bg-background-chrome px-8'>
      <button
        type='button'
        className='flex w-full items-center gap-2 bg-background-chrome p-4 text-text-primary md:hidden'
        id='menu-button'
        aria-expanded={isMenuOpen}
        onClick={() => {
          setIsMenuOpen(!isMenuOpen)
        }}
      >
        <div className='flex flex-col space-y-1 focus:outline-none'>
          <span className='block h-0.5 w-6 bg-action-primary-background'></span>

          <span className='block h-0.5 w-6 bg-action-primary-background'></span>

          <span className='block h-0.5 w-6 bg-action-primary-background'></span>
        </div>
        Menu
      </button>

      <div className='flex flex-row justify-end items-center gap-4'>
        <Link to='/notificaties'>
          {unreadNotificationsCount > 0 && (
            <div className='relative'>
              <div className='absolute top-3 left-2 z-10 flex h-4 w-4 items-center justify-center rounded-full bg-action-primary-background'>
                <p className='text-xs text-action-primary-foreground'>
                  {unreadNotificationsCount}
                </p>
              </div>
            </div>
          )}

          <FontAwesomeIcon
            size='xl'
            icon='bell'
            className='text-icon-secondary'
            aria-label={'Bekijk meldingen'}
          />
        </Link>

        <Link to='/mijn-profiel'>
          <div className='flex flex-row gap-[8px] items-center'>
            <FontAwesomeIcon
              icon='user'
              className='hidden text-icon-secondary md:block'
              size='lg'
              aria-label='Bekijk profiel'
            />

            <FontAwesomeIcon
              icon='user'
              className='block text-icon-secondary md:hidden'
              size='xl'
              aria-label='Bekijk profiel'
            />

            <p className='hidden text-[14px] text-text-primary md:block'>{fullName}</p>
          </div>

          <p className='light hidden md:block'>{`Combinummer: ${resourceAuthorization?.combiNumber}`}</p>
        </Link>

        <div
          className={`${
            isMenuOpen ? 'translate-x-0' : '-translate-x-full'
          } fixed top-0 left-0 z-50 h-full w-64 transform bg-background-chrome transition-transform duration-300 ease-in-out`}
        >
          <button
            type='button'
            className='flex h-[60px] w-full items-center gap-4 border-b-[0.5px] border-border-subtle px-8 text-text-primary'
            id='menu-button'
            aria-expanded={isMenuOpen}
            onClick={() => {
              setIsMenuOpen(!isMenuOpen)
            }}
          >
            <div className='flex flex-col space-y-1 focus:outline-none'>
              <span className='block h-0.5 w-6 bg-action-primary-background'></span>

              <span className='block h-0.5 w-6 bg-action-primary-background'></span>

              <span className='block h-0.5 w-6 bg-action-primary-background'></span>
            </div>
            Menu
          </button>

          {getButtons(relationToggles?.cooperationMembership ?? false).map(
            (item) => (
              <NavBarItem
                key={`nav-header-item-${item.href}`}
                href={item.href}
                icon={item.icon}
                title={item.title}
              />
            )
          )}
        </div>
      </div>

      {isMenuOpen && (
        <div
          className='fixed inset-0 z-40 bg-overlay-scrim'
          onClick={() => {
            setIsMenuOpen(false)
          }}
        />
      )}
    </div>
  )
}

export default ScreenHeader
